import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { GenericService } from '../../generic.service';
import { issueListEuht } from '../../../assets/data/poorResults-euht';
import { CommonModule } from '@angular/common';
import { LandingService } from '../../landing-page/service/landing.service';
import { defaultLanguage } from '../../shared/constants/language.constants';
import { CrowdinService } from '../../shared/service/crowdin.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-poor-results-euht',
    imports: [CommonModule, RouterModule],
    templateUrl: './poor-results-euht.component.html',
    styleUrl: './poor-results-euht.component.scss'
})
export class PoorResultsEuhtComponent {
  private readonly noDebrisKeyValue = 6;
  private readonly noLimescaleKeyValue = 8;
  deviceData: any = {};
  deviceData$: any = null;
  isDebris: boolean = false;
  isLimescale: boolean = false;
  issueName: string | undefined;
  accountNumber: string = '';
  showImagePopup: boolean = false;
  popupImages: string[] = [];
  showPopup: boolean = false;
  issueListEuht: any = {};
  languageDetails!: (item: any) => any;
  languageIndex: number = 0;
  translations: { [key: string]: string } = {};
  currentLanguage: string = defaultLanguage;
  languageOptions: Array<{ value: string }> = [];
  isLoadingTranslations = true;
  subs = new Subscription();

  constructor(
    private router: Router,
    private genericService: GenericService,
    private landingService: LandingService,
    private crowdinService: CrowdinService,
  ) {
    this.deviceData$ = this.genericService.deviceData.subscribe((data) => {
      if (data) {
        this.deviceData = data;
      }
    });
  }

  ngOnInit() {
    this.issueListEuht = structuredClone(issueListEuht);
    this.getTranslations();
    this.languageOptions = this.landingService.getLanguageOptions();
    this.subs.add(
      this.landingService.languageName$.subscribe((langName) => {
        this.currentLanguage = langName;
        this.translations = this.crowdinService.getAllTranslations();
        this.getTranslations();
      }),
    );

    this.landingService.loadTranslations(this.currentLanguage);
  }

  async languageChange(event: any) {
    const selectedLang = event.target.value;
    await this.landingService.loadTranslations(selectedLang);
    this.getTranslations();
  }

  ngOnDestroy(): void {
    if (this.deviceData$) {
      this.deviceData$.unsubscribe();
    }

    this.subs.unsubscribe();
  }

  goBack() {
    this.deviceData['languageSelected'] = this.currentLanguage;
    this.genericService.setLocalStorage(this.deviceData);
    this.genericService.deviceData.next(this.deviceData);
    history.go(-1);
  }

  navigateToLandingPage() {
    this.landingService.navigateToHomePage();
    this.deviceData['languageSelected'] = this.currentLanguage;
    this.genericService.setLocalStorage(this.deviceData);
    this.genericService.deviceData.next(this.deviceData);
  }

  get progress() {
    const answered = this.issueListEuht.filter(
      (item: { answered: any }) => item.answered,
    ).length;
    return (answered / this.issueListEuht.length) * 100;
  }

  getTranslations() {
    const name = this.currentLanguage || defaultLanguage;
    const key = name.toLowerCase();

    this.issueListEuht = this.issueListEuht.map((item: any) => ({
      ...item,
      translatedTitle:
        this.translations?.[item.titleKey] ??
        item?.title?.[key] ??
        item?.title?.english ??
        '',
      translatedDetails: (
        this.translations?.[item.detailsKey] ??
        item?.details?.[key] ??
        item?.details?.english ??
        ''
      ).trim(),
    }));
  }

  toggleAccordion(index: number) {
    this.issueListEuht[index].expanded = !this.issueListEuht[index].expanded;
  }

  resolved() {
    this.deviceData['languageSelected'] = this.currentLanguage;
    this.genericService.setLocalStorage(this.deviceData);
    this.genericService.deviceData.next(this.deviceData);
    this.router.navigateByUrl('thankYou');
  }

  needHelp() {
    this.landingService.needHelp();
  }

  openPopup(item: any) {
    this.popupImages = item.images;
    this.isDebris = item?.keyValue === this.noDebrisKeyValue;
    this.isLimescale = false;
    this.showPopup = true;
  }

  openImagePopup(images: string[], item: any) {
    this.popupImages = images;
    this.isDebris = false;
    this.isLimescale = item?.keyValue === this.noLimescaleKeyValue;
    this.showImagePopup = true;
  }

  closePopup() {
    this.showPopup = false;
    this.showImagePopup = false;
  }

  answer(index: number, status: string) {
    this.issueListEuht[index].status = status;
    this.issueListEuht[index].answered = true;
    if (this.issueListEuht[index].translatedDetails !== '') {
      this.issueListEuht[index].expanded = true;
    }
  }
}
